module.exports = __webpack_public_path__ + "static/img/top5-green.465ae54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top5-green.png
// module id = BeYj
// module chunks = 9